import { create } from "zustand";

export const useToast = create((set) => ({
  title: "",
  message: "",
  variant: "",
  setToaster: (title, message, variant) => {
    set({ title, message, variant });
  },
}));
